module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('el-col', {
    staticClass: "report-categories",
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "report-category",
    class: _vm.reportCategory === 0 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(0)
      }
    }
  }, [_vm._v("\n                統計總覽\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "report-category",
    class: _vm.reportCategory === 1 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(1)
      }
    }
  }, [_vm._v("\n                閱覽記錄\n            ")]), _vm._v(" "), (this.$store.state.isSystemAdminMode) ? _c('div', {
    staticClass: "report-category",
    class: _vm.reportCategory === 2 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(2)
      }
    }
  }, [_vm._v("\n                批次匯出閱覽記錄\n            ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "report-title"
  }, [_c('div', [(_vm.$store.state.report.isShowPersonalDetail && (_vm.reportCategory === 1)) ? _c('div', {
    staticClass: "text-link",
    on: {
      "click": function($event) {
        return _vm.resetPersonalDetail()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.categoryTitle) + " \n                    ")]) : _c('div', [_vm._v("\n                        " + _vm._s(_vm.categoryTitle) + " \n                    ")])]), _vm._v(" "), (_vm.reportCategory === 1) ? _c('div', {
    staticStyle: {
      "margin-right": "auto"
    }
  }, [(_vm.$store.state.report.isShowPersonalDetail) ? _c('div', [_vm._v("\n                        >  " + _vm._s(this.$store.state.report.personalListStatus.name) + " (" + _vm._s(this.$store.state.report.personalListStatus.id) + ")\n                    ")]) : _c('el-cascader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.isSystemAdminMode),
      expression: "$store.state.isSystemAdminMode"
    }],
    staticClass: "menu-select",
    attrs: {
      "placeholder": "",
      "show-all-levels": false,
      "options": _vm.actualDepsOptions
    },
    on: {
      "change": _vm.handleActualDepSelect
    },
    model: {
      value: (_vm.$store.state.report.selectedDepId),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.report, "selectedDepId", $$v)
      },
      expression: "$store.state.report.selectedDepId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-date-picker', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "選擇日期範圍",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.$store.state.report.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.report, "dateRange", $$v)
      },
      expression: "$store.state.report.dateRange"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "report-content"
  }, [(_vm.reportCategory === 0) ? _c('el-row', [_c('ReportOverview')], 1) : (_vm.reportCategory === 1) ? _c('el-row', [_c('ReportDetail')], 1) : (_vm.reportCategory === 2) ? _c('el-row', [_c('ReportDetailExport', {
    on: {
      "searchHint": _vm.showHint
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.report),
      expression: "hint.display && this.$store.state.hintStatus.report"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-765e0556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Report.vue
// module id = 940
// module chunks = 170